import React from 'react';
import gql from 'graphql-tag';
import {FieldConfigurationFragment} from '../../../scenes/app/formConfiguration/fragments';
import Tip, {TipType} from '../../../ui/Tip';
import SimpleFieldForm, {SimpleFieldFormProps} from './SimpleFieldForm';

export default function StarRatingForm({
  sectionId, defaultLanguage, configuration, onCreateUpdate,
}: SimpleFieldFormProps) {
  const tip = (
    <Tip type={TipType.Info} className="mb-3">
      5 stars rating
    </Tip>
  );

  return (
    <SimpleFieldForm sectionId={sectionId} configuration={configuration} defaultLanguage={defaultLanguage}
      onCreateUpdate={onCreateUpdate} createMutation={createMutation} updateMutation={updateMutation}
      tip={tip}/>
  );
}

const createMutation = gql`
  mutation CreateMutation($type: FormType!, $data: StarRatingInput!) {
    field: createStarRatingField(type: $type, data: $data) {
      ...CompleteFieldConfiguration
    }
  }
  ${FieldConfigurationFragment}
`;

const updateMutation = gql`
  mutation UpdateMutation($id: ID!, $type: FormType!, $data: StarRatingInput!) {
    field: updateStarRatingField(id: $id, type: $type, data: $data) {
      ...CompleteFieldConfiguration
    }
  }
  ${FieldConfigurationFragment}
`;
